/**
 * Created by vblanco on 28/04/2017.
 */
(function () {
    'use strict';

    angular
        .module('app')
        .config(stateConfig);

    /* @ngInject */
    function stateConfig($stateProvider, STATE_HELPER) {
        var base = "admin/epiteto";
        var params = {
            base: base,
            baseUrl: "/" + base,
            templateUrlBase: "app/admin/tesauro/epiteto/epiteto",
            controller: 'EpitetoAdminController',
            controllerForm: 'EpitetoFormAdminController',
            translateBase: "admin.epiteto."
        };

        var state = STATE_HELPER(params);
        // Estado Padre
        angular.merge(state.parent, {
            data: {
                authorities: ['ROLE_ADMIN']

            }
        });
        // Listar y letras
        angular.merge(state.list, {
            resolve: {
                /* @ngInject */
                letras: function (Epiteto) {
                    return Epiteto.findUsedLetters().$promise.then(function (data) {
                        return data;
                    });
                 }
            },
            url: '/listar/:letra/:page',
            params: {
                page:'1',
                letra: 'TODO'
            }
        });

        // Se definen los estados
        $stateProvider
            .state(params.base, state.parent)
            .state(state.list.name, state.list)


    }
})();
